import { SubIndexCodes } from 'store/vibrancy/reducerSlice'
import { DataKey, MetricType } from '../types'

export * from './rankedColor'

export const DATA_FILE_PATH = '/data/'
// export const DATA_FILE_NAME = 'full_data_06.27.24'
// export const DATA_FILE_NAME = 'full_data_10.28.24'                  Data used before full_data_07.22.24
export const DATA_FILE_NAME = 'full_data_09.24.25'
// export const DATA_FILE_NAME = 'full_data_07.22.24'
export const LEGEND_FILE_NAME = 'national_ai_strategy_by_status_over_time'
export const LEGEND_YEAR_FILE_NAME = 'national_ai_strategy_release_year'
// export const DATA_FILE_NAME = 'full_data_Apr2024'
export const CODEBOOK_FILE_PATH = '/data/'
// export const CODEBOOK_FILE_NAME = 'codebook_06.27.24'              Data used before codebook_07.22.24
export const CODEBOOK_FILE_NAME = 'codebook_09.24.25'
// export const VARIABLE_LIST = 'variable_list_06.27.24'              Data used before variable_list_07.22.24
export const VARIABLE_LIST = 'variable_list_09.24.25'
// export const CODEBOOK_FILE_NAME = 'codebook_4'

export enum COLOR {
  LIGHT = '#e4e4e4',
  DARK = '#172E5C',
  TEXT = '#73D9FF',
  WHITE = '#FFFFFF',
  NAVY = '#041b33',
  NAVY2 = '#75c1e1',
  NAVY3 = '#3a80b7',
  BAR1 = 'rgba(58, 141, 199, 1)',
  BAR2 = 'rgba(36, 148, 153, 1)',
  BAR1LIGHT = 'rgba(58, 141, 199, 0.8)',
  BAR2LIGHT = 'rgba(36, 148, 153, 0.8)',
  CARRET = 'rgba(50, 115, 220, 1)',

  BAR3 = '#872996',
  BAR3LIGHT = '#87299680',
  BAR4 = '#89D0E5',
  BAR4LIGHT = '#89D0E580',
  BAR5 = '#eaadff',
  BAR5LIGHT = '#eaadff80',
  BAR6 = '#4d1f52',
  BAR6LIGHT = '#4d1f5280',
  BAR7 = '#9cf2f2',
  BAR7LIGHT = '#9cf2f280',
  BAR8 = '#172e5c',
  BAR8LIGHT = '#172e5c80',
}

export const GROUPING_LIST = [
  { displayName: 'Pillar', name: 'pillar', headerKey: 'Pillar' },
  { displayName: 'Region', name: 'region', headerKey: 'Region' },
  { displayName: 'Income Group', name: 'incomeGroup', headerKey: 'IncomeGroup' },
]

export const INCOME_GROUP_INFO = [
  {
    displayName: 'High Income',
    name: 'High income',
    color: 'rgba(12,107,113,255)',
    lightColor: 'rgba(12,107,113,0.8)',
  },
  {
    displayName: 'Upper Middle Income',
    name: 'Upper middle income',
    color: 'rgba(28,196,186,255)',
    lightColor: 'rgba(28,196,186,0.8)',
  },
  {
    displayName: 'Lower Middle Income',
    name: 'Lower middle income',
    color: 'rgba(235,172,255,255)',
    lightColor: 'rgba(235,172,255,0.8)',
  },
  {
    displayName: 'Low Income',
    name: 'Low Income',
    color: 'rgba(134,40,150,255)',
    lightColor: 'rgba(134,40,150,0.8)',
  },
]

export const REGION_INFO = [
  {
    displayName: 'East Asia & Pacific',
    name: 'East Asia & Pacific',
    color: 'rgba(235,172,255,255)',
    lightColor: 'rgba(235,172,255,0.8)',
  },
  {
    displayName: 'Europe & Central Asia',
    name: 'Europe & Central Asia',
    color: 'rgba(28,196,186,255)',
    lightColor: 'rgba(28,196,186,0.8)',
  },
  {
    displayName: 'Latin America & Caribbean',
    name: 'Latin America & Caribbean',
    color: 'rgba(115,216,254,255)',
    lightColor: 'rgba(115,216,254,0.8)',
  },
  {
    displayName: 'Middle East & North Africa',
    name: 'Middle East & North Africa',
    color: 'rgba(77,30,83,255)',
    lightColor: 'rgba(77,30,83,0.8)',
  },
  {
    displayName: 'North America',
    name: 'North America',
    color: 'rgba(28,120,186,255)',
    lightColor: 'rgba(28,120,186,0.8)',
  },
  { displayName: 'South Asia', name: 'South Asia', color: 'rgba(199,93,215,255)', lightColor: 'rgba(199,93,215,0.8)' },
  {
    displayName: 'Sub-Saharan Africa',
    name: 'Sub-Saharan Africa',
    color: 'rgba(28,75,78,255)',
    lightColor: 'rgba(28,75,78,0.8)',
  },
]

export const NUMBER_OF_YEAR_IN_REPORT = 2

export type PillarType = Record<string, string | number> & {
  displayName: string
  name: string
  color: string
  lightColor: string
  dataKey: DataKey
  metricType: MetricType
  defaultMultiplier: number
}

export type Indicators = {
  metricName: string
  metricDataKey: string
  shortname_raw: string
  shortname_scale: string
  shortname_raw_pc: string
  shortname_scale_pc: string
}

export interface SubIndicesData {
  indexName: string
  indexCode: SubIndexCodes
  pillarList: string[]
  indicators: Indicators[]
  description: string
}

export interface IG20Countries {
  countryCode: string
  countryLongCode: string
  countryName: string
}

export const PILLAR_INFO: PillarType[] = [
  {
    // displayName: 'R&D',
    displayName: 'R&D',
    // name: 'Research and Development', // Old code book
    name: 'R&D', // New code book 27.06.2024
    color: COLOR.BAR1,
    lightColor: COLOR.BAR1LIGHT,
    dataKey: 'research',
    metricType: 'rad',
    defaultMultiplier: 1,
  },
  {
    // displayName: 'RESPONSIBLE AI',
    displayName: 'Responsible AI',
    name: 'Responsible AI',
    color: COLOR.BAR3,
    lightColor: COLOR.BAR3LIGHT,
    dataKey: 'responsible',
    metricType: 'rai',
    defaultMultiplier: 0.2,
  },
  {
    // displayName: 'ECONOMY',
    displayName: 'Economy',
    name: 'Economy',
    color: COLOR.BAR2,
    lightColor: COLOR.BAR2LIGHT,
    dataKey: 'economy',
    metricType: 'eco',
    defaultMultiplier: 0.8,
  },
  {
    // displayName: 'ECONOMY',
    displayName: 'Talent',
    name: 'Talent',
    color: COLOR.BAR5,
    lightColor: COLOR.BAR5LIGHT,
    dataKey: 'talent',
    metricType: 'tal',
    defaultMultiplier: 0.6,
  },

  // {
  //   // displayName: 'EDUCATION',
  //   displayName: 'Education',
  //   name: 'Education',
  //   color: COLOR.BAR4,
  //   lightColor: COLOR.BAR4LIGHT,
  //   dataKey: 'education',
  //   metricType: 'edu',
  //   defaultMultiplier: 0.2,
  // },
  // {
  //   // displayName: 'DIVERSITY',
  //   displayName: 'Diversity',
  //   name: 'Diversity',
  //   color: COLOR.BAR5,
  //   lightColor: COLOR.BAR5LIGHT,
  //   dataKey: 'diversity',
  //   metricType: 'div',
  //   defaultMultiplier: 0.1,
  // },
  {
    // displayName: 'POLICY AND GOVERNANCE',
    displayName: 'Policy and Governance',
    name: 'Policy and Governance',
    color: COLOR.BAR6,
    lightColor: COLOR.BAR6LIGHT,
    dataKey: 'policy',
    metricType: 'pol',
    defaultMultiplier: 0.2,
  },
  {
    // displayName: 'PUBLIC OPINION',
    displayName: 'Public Opinion',
    name: 'Public Opinion',
    lightColor: COLOR.BAR7LIGHT,
    color: COLOR.BAR7,
    dataKey: 'publicOpinion',
    metricType: 'pub',
    defaultMultiplier: 0.2,
  },
  {
    // displayName: 'INFRASTRUCTURE',
    displayName: 'Infrastructure',
    name: 'Infrastructure',
    lightColor: COLOR.BAR8LIGHT,
    color: COLOR.BAR8,
    dataKey: 'infrastructure',
    metricType: 'inf',
    defaultMultiplier: 0.6,
  },
]

export const METRIC_DEFAULT_MULTIPLIER = {
  'AI Publications (Total)': 7,
  'AI Citations (Total)': 8,
  'AI Patent Grants': 8,
  'Notable AI Models': 9,
  'Academia-Industry Model Production Concentration': 0,
  'AI GitHub Projects': 7,
  'AI GitHub Projects Stars': 8,
  'Conference Submissions on RAI Topics (Total)': 8,
  'Total AI Private Investment': 10,
  'Newly Funded AI Companies': 9,
  'AI Hiring Rate YoY Ratio': 6,
  'Relative AI Skill Penetration': 3,
  'AI Talent Concentration': 6,
  'AI Job Postings (% of Total)': 0,
  'Net Migration Flow of AI Skills': 6,
  'AI Legislation Passed (3-Year MA)': 10,
  'AI Mentions in Legislative Proceedings': 6,
  'AI Social Media Posts': 6,
  'AI-Related Social Media Conversations Net Sentiment': 9,
  'Parts Semiconductor Devices Exports': 10,
  // eslint-disable-next-line prettier/prettier
  Supercomputers: 9,
  'Compute Capacity (Rmax)': 10,
  'Internet Speed': 8,
}

export const DOWNLOAD_FILE_NAME = {
  aiMetricOverTime: 'AI-metric-over-time-bar',
  aiMetricOverTimeWorldMap: 'AI-metric-over-time-worldmap',
  globalAiVibrancyRankingBar: 'Global-AI-vibrancy-ranking-bar',
  nationalAiVibrancyRankingBar: 'National-AI-vibrancy-ranking-bar',
  globalAiVibrancyRankingTable: 'Global-AI-vibrancy-ranking-table',
  countryReport: 'Country-report',
  slopeChart: 'Global-AI-vibrancy-slope-chart',
  subIndicesChart: {
    II: 'Innovation-index',
    ECI: 'Economic-competitive-index',
    PGPEI: 'Policy-governance-and-public-engagement-index',
  },
}

export const METRIC_ENDPOINT_WEIGHT = '_weight'
export const METRIC_ENDPOINT_RANK = '_rank'

export const COVERAGE_RANGES = [
  {
    color: '#E7E7E7',
    title: 'No data',
  },
  {
    color: '#79CCEC',
    title: '0–75%',
  },
  {
    color: '#428BC5',
    title: '76–85%',
  },
  {
    color: '#132E69',
    title: '86–100%',
  },
]

export const BAR_CHART_DOMAIN_RANGES = [
  0.0005, 0.001, 0.005, 0.01, 0.5, 1, 2, 3, 5, 10, 20, 30, 40, 50, 60, 70, 80, 100, 150, 200, 250, 300, 400, 500, 700,
  1000, 2000, 3500, 5000, 6000, 7000, 15000, 20000, 40000, 45000,
]

export const BAR_CHART_TICK_RANGES = (isSmaller600: boolean) => [
  { max: 0.0005, ticks: [0, 0.0001, 0.0002, 0.0003, 0.0004, 0.0005] },
  { max: 0.001, ticks: [0, 0.0005, 0.001] },
  { max: 0.005, ticks: [0, 0.001, 0.002, 0.003, 0.004, 0.005] },
  { max: 0.01, ticks: [0, 0.005, 0.01] },
  { max: 0.5, ticks: [0, 0.1, 0.2, 0.3, 0.4, 0.5] },
  { max: 1, ticks: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] },
  { max: 2, ticks: [0, 0.5, 1, 1.5, 2] },
  { max: 3, ticks: [0, 1, 2, 3] },
  { max: 5, ticks: Array.from({ length: 6 }, (_, i) => i) },
  { max: 10, ticks: Array.from({ length: 11 }, (_, i) => i) },
  { max: 20, ticks: Array.from({ length: 5 }, (_, i) => i * 5) },
  { max: 30, ticks: Array.from({ length: 7 }, (_, i) => i * 5) },
  { max: 40, ticks: Array.from({ length: 9 }, (_, i) => i * 5) },
  { max: 50, ticks: Array.from({ length: 11 }, (_, i) => i * 5) },
  { max: 60, ticks: Array.from({ length: 7 }, (_, i) => i * 10) },
  { max: 70, ticks: Array.from({ length: 8 }, (_, i) => i * 10) },
  { max: 80, ticks: Array.from({ length: 9 }, (_, i) => i * 10) },
  { max: 100, ticks: Array.from({ length: 11 }, (_, i) => i * 10) },
  { max: 150, ticks: Array.from({ length: 7 }, (_, i) => i * 25) },
  { max: 200, ticks: Array.from({ length: 9 }, (_, i) => i * 25) },
  { max: 250, ticks: Array.from({ length: 6 }, (_, i) => i * 50) },
  { max: 300, ticks: Array.from({ length: 7 }, (_, i) => i * 50) },
  { max: 400, ticks: Array.from({ length: 9 }, (_, i) => i * 50) },
  { max: 500, ticks: Array.from({ length: 11 }, (_, i) => i * 50) },
  { max: 700, ticks: Array.from({ length: 8 }, (_, i) => i * 100) },
  { max: 1000, ticks: Array.from({ length: 6 }, (_, i) => i * 200) },
  { max: 2000, ticks: Array.from({ length: 5 }, (_, i) => i * 500) },
  { max: 3500, ticks: Array.from({ length: 8 }, (_, i) => i * 500) },
  { max: 5000, ticks: Array.from({ length: isSmaller600 ? 6 : 11 }, (_, i) => i * (isSmaller600 ? 1000 : 500)) },
  { max: 6000, ticks: Array.from({ length: 7 }, (_, i) => i * 1000) },
  { max: 7000, ticks: Array.from({ length: 8 }, (_, i) => i * 1000) },
  { max: 15000, ticks: Array.from({ length: 4 }, (_, i) => i * 5000) },
  { max: 20000, ticks: Array.from({ length: 5 }, (_, i) => i * 5000) },
  { max: 40000, ticks: Array.from({ length: 9 }, (_, i) => i * 5000) },
  { max: 45000, ticks: Array.from({ length: isSmaller600 ? 4 : 10 }, (_, i) => i * (isSmaller600 ? 15000 : 5000)) },
]

export const PDF_WIDTH = 210.0015555555555
export const SCALE_VALUE = 1.8
export const AIOT_ODD_CASE = ['national_ai_strategy_is_released', 'pc_national_ai_strategy_is_released']

//SUB-INDICES
export const II_SUB_INDEX_INDICATORS: Indicators[] = [
  {
    metricName: 'AI Publications (Total)',
    metricDataKey: 'research',
    shortname_raw: 'number_of_total_publications',
    shortname_scale: 'norm_number_of_total_publications',
    shortname_raw_pc: 'pc_number_of_total_publications',
    shortname_scale_pc: 'norm_pc_number_of_total_publications',
  },
  {
    metricName: 'AI Citations (Total)',
    metricDataKey: 'research',
    shortname_raw: 'number_of_total_citations',
    shortname_scale: 'norm_number_of_total_citations',
    shortname_raw_pc: 'pc_number_of_total_citations',
    shortname_scale_pc: 'norm_pc_number_of_total_citations',
  },
  {
    metricName: 'AI Patent Grants',
    metricDataKey: 'research',
    shortname_raw: 'number_of_total_patent_grants',
    shortname_scale: 'norm_number_of_total_patent_grants',
    shortname_raw_pc: 'pc_number_of_total_patent_grants',
    shortname_scale_pc: 'norm_pc_number_of_total_patent_grants',
  },
  {
    metricName: 'Notable AI Models',
    metricDataKey: 'research',
    shortname_raw: 'number_of_notable_ml_models',
    shortname_scale: 'norm_number_of_notable_ml_models',
    shortname_raw_pc: 'pc_number_of_notable_ml_models',
    shortname_scale_pc: 'norm_pc_number_of_notable_ml_models',
  },
  {
    metricName: 'AI GitHub Projects',
    metricDataKey: 'research',
    shortname_raw: 'number_of_github_repos',
    shortname_scale: 'norm_number_of_github_repos',
    shortname_raw_pc: 'pc_number_of_github_repos',
    shortname_scale_pc: 'norm_pc_number_of_github_repos',
  },
  {
    metricName: 'AI GitHub Projects Stars',
    metricDataKey: 'research',
    shortname_raw: 'number_of_github_stars',
    shortname_scale: 'norm_number_of_github_stars',
    shortname_raw_pc: 'pc_number_of_github_stars',
    shortname_scale_pc: 'norm_pc_number_of_github_stars',
  },
  {
    metricName: 'Parts Semiconductor Devices Exports',
    metricDataKey: 'infrastructure',
    shortname_raw: 'parts_semiconductor_devices_export_value',
    shortname_scale: 'norm_parts_semiconductor_devices_export_value',
    shortname_raw_pc: 'pc_parts_semiconductor_devices_export_value',
    shortname_scale_pc: 'norm_pc_parts_semiconductor_devices_export_value',
  },
  {
    metricName: 'Supercomputers',
    metricDataKey: 'infrastructure',
    shortname_raw: 'number_of_supercomputers',
    shortname_scale: 'norm_number_of_supercomputers',
    shortname_raw_pc: 'pc_number_of_supercomputers',
    shortname_scale_pc: 'norm_pc_number_of_supercomputers',
  },
  {
    metricName: 'Compute Capacity (Rmax)',
    metricDataKey: 'infrastructure',
    shortname_raw: 'compute_capacity_rmax_gflops',
    shortname_scale: 'norm_compute_capacity_rmax_gflops',
    shortname_raw_pc: 'pc_compute_capacity_rmax_gflops',
    shortname_scale_pc: 'norm_pc_compute_capacity_rmax_gflops',
  },
  {
    metricName: 'Internet Speed',
    metricDataKey: 'infrastructure',
    shortname_raw: 'internet_speed_median_download_mbps',
    shortname_scale: 'norm_internet_speed_median_download_mbps',
    shortname_raw_pc: 'pc_internet_speed_median_download_mbps',
    shortname_scale_pc: 'norm_pc_internet_speed_median_download_mbps',
  },
]

export const ECI_SUB_INDEX_INDICATORS: Indicators[] = [
  {
    metricName: 'Total AI Private Investment',
    metricDataKey: 'economy',
    shortname_raw: 'private_investment',
    shortname_scale: 'norm_private_investment',
    shortname_raw_pc: 'pc_private_investment',
    shortname_scale_pc: 'norm_pc_private_investment',
  },
  {
    metricName: 'Newly Funded AI Companies',
    metricDataKey: 'economy',
    shortname_raw: 'number_of_newly_funded_companies',
    shortname_scale: 'norm_number_of_newly_funded_companies',
    shortname_raw_pc: 'pc_number_of_newly_funded_companies',
    shortname_scale_pc: 'norm_pc_number_of_newly_funded_companies',
  },
  {
    metricName: 'AI Hiring Rate YoY Ratio',
    metricDataKey: 'talent',
    shortname_raw: 'relative_ai_hiring_rate_yoy_ratio',
    shortname_scale: 'norm_relative_ai_hiring_rate_yoy_ratio',
    shortname_raw_pc: '-',
    shortname_scale_pc: '-',
  },
  {
    metricName: 'Relative AI Skill Penetration',
    metricDataKey: 'talent',
    shortname_raw: 'relative_ai_skills_penetration',
    shortname_scale: 'norm_relative_ai_skills_penetration',
    shortname_raw_pc: '-',
    shortname_scale_pc: '-',
  },
  {
    metricName: 'AI Talent Concentration',
    metricDataKey: 'talent',
    shortname_raw: 'ai_talent_concentration',
    shortname_scale: 'norm_ai_talent_concentration',
    shortname_raw_pc: 'pc_ai_talent_concentration',
    shortname_scale_pc: 'norm_pc_ai_talent_concentration',
  },
  {
    metricName: 'Net Migration Flow of AI Skills',
    metricDataKey: 'talent',
    shortname_raw: 'net_migration_flow_ai_skills_per_10k',
    shortname_scale: 'norm_net_migration_flow_ai_skills_per_10k',
    shortname_raw_pc: 'pc_net_migration_flow_ai_skills_per_10k',
    shortname_scale_pc: 'norm_pc_net_migration_flow_ai_skills_per_10k',
  },
]

export const PGPEI_SUB_INDEX_INDICATORS: Indicators[] = [
  {
    metricName: 'AI Legislation Passed (3-Year MA)',
    metricDataKey: 'policy',
    shortname_raw: 'num_ai_related_bills_passed_3y_moving_average',
    shortname_scale: 'norm_num_ai_related_bills_passed_3y_moving_average',
    shortname_raw_pc: 'pc_num_ai_related_bills_passed_3y_moving_average',
    shortname_scale_pc: 'norm_pc_num_ai_related_bills_passed_3y_moving_average',
  },
  {
    metricName: 'AI Mentions in Legislative Proceedings',
    metricDataKey: 'policy',
    shortname_raw: 'ai_mentions_in_legislative_proceedings',
    shortname_scale: 'norm_ai_mentions_in_legislative_proceedings',
    shortname_raw_pc: 'pc_ai_mentions_in_legislative_proceedings',
    shortname_scale_pc: 'norm_pc_ai_mentions_in_legislative_proceedings',
  },
  {
    metricName: 'AI Social Media Posts',
    metricDataKey: 'publicOpinion',
    shortname_raw: 'ai_social_media_posts',
    shortname_scale: 'norm_ai_social_media_posts',
    shortname_raw_pc: 'pc_ai_social_media_posts',
    shortname_scale_pc: 'norm_pc_ai_social_media_posts',
  },
  {
    metricName: 'AI-Related Social Media Conversations Net Sentiment',
    metricDataKey: 'publicOpinion',
    shortname_raw: 'ai_social_media_conversations_net_sentiment',
    shortname_scale: 'norm_ai_social_media_conversations_net_sentiment',
    shortname_raw_pc: 'pc_ai_social_media_conversations_net_sentiment',
    shortname_scale_pc: 'norm_pc_ai_social_media_conversations_net_sentiment',
  },
]

export const SUB_INDICES_INFO: SubIndicesData[] = [
  {
    indexName: 'Innovation Index',
    indexCode: 'II',
    pillarList: ['research', 'infrastructure'],
    indicators: II_SUB_INDEX_INDICATORS,
    description:
      'The Innovation index measures a country’s innovation potential by assessing its research and development (R&D) activities, academic output, technological advancements, intellectual property generation, and supporting technological infrastructure. It highlights a country’s capacity to produce new knowledge, innovate, and contribute to global AI advancements. The index offers insights into which countries are leading in AI development and have the necessary infrastructure to support future progress.',
  },
  {
    indexName: 'Economic Competitiveness Index',
    indexCode: 'ECI',
    pillarList: ['economy', 'talent'],
    indicators: ECI_SUB_INDEX_INDICATORS,
    description:
      'The Economic Competitiveness index measures the economic strength and market dynamism of a country in the AI sector by analyzing investment flows, talent concentration, and job creation. It captures how countries are leading in integrating AI into their economies, enhancing their competitive edge, and creating robust ecosystems for AI-driven growth.',
  },
  {
    indexName: 'Policy, Governance, and Public Engagement Index',
    indexCode: 'PGPEI',
    pillarList: ['policy', 'publicOpinion'],
    indicators: PGPEI_SUB_INDEX_INDICATORS,
    description:
      'The Policy, Governance, and Public Engagement Index index evaluates the level of activity related to AI-related policies, legislative actions, and the broader public discourse surrounding AI. It identifies which countries are leaders in creating an enabling policy environment for AI and how public opinion is shaping the adoption and acceptance of AI technologies. Countries with a national strategy on AI and positive public sentiment are better positioned to leverage AI for national development, while those lagging may face challenges in governance, public trust, and AI deployment.',
  },
]

//G20 COUNTRIES
export const G20_COUNTRIES: IG20Countries[] = [
  {
    countryCode: 'US',
    countryLongCode: 'USA',
    countryName: 'United States',
  },
  {
    countryCode: 'CN',
    countryLongCode: 'CHN',
    countryName: 'China',
  },
  {
    countryCode: 'CA',
    countryLongCode: 'CAN',
    countryName: 'Canada',
  },
  {
    countryCode: 'IN',
    countryLongCode: 'IND',
    countryName: 'India',
  },
  {
    countryCode: 'KR',
    countryLongCode: 'KOR',
    countryName: 'South Korea',
  },
  {
    countryCode: 'GB',
    countryLongCode: 'GBR',
    countryName: 'United Kingdom',
  },
  {
    countryCode: 'DE',
    countryLongCode: 'DEU',
    countryName: 'Germany',
  },
  {
    countryCode: 'JP',
    countryLongCode: 'JPN',
    countryName: 'Japan',
  },
  {
    countryCode: 'AU',
    countryLongCode: 'AUS',
    countryName: 'Australia',
  },
  {
    countryCode: 'FR',
    countryLongCode: 'FRA',
    countryName: 'France',
  },
  {
    countryCode: 'BR',
    countryLongCode: 'BRA',
    countryName: 'Brazil',
  },
  {
    countryCode: 'MX',
    countryLongCode: 'MEX',
    countryName: 'Mexico',
  },
  {
    countryCode: 'ZA',
    countryLongCode: 'ZAF',
    countryName: 'South Africa',
  },
  {
    countryCode: 'IT',
    countryLongCode: 'ITA',
    countryName: 'Italy',
  },
  {
    countryCode: 'RU',
    countryLongCode: 'RUS',
    countryName: 'Russia',
  },
  {
    countryCode: 'SA',
    countryLongCode: 'SAU',
    countryName: 'Saudi Arabia',
  },
  {
    countryCode: 'TR',
    countryLongCode: 'TUR',
    countryName: 'Turkey',
  },
]

export interface ISWData {
  countryCode: string
  countryName: string
  swData: ISWMetaData[]
}

export interface ISWMetaData {
  publishYear: number
  strengths: IStrength[]
  weaknesses: IStrength[]
}

export interface IStrength {
  index: number
  text: string
  metricSmallName: string
  metricType: 'absolute' | 'perCapita'
}

export const SWData: ISWData[] = [
  {
    countryCode: 'US',
    countryName: 'United States',
    swData: [
      {
        publishYear: 2017,
        strengths: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_publications',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_publications',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_citations',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_publications',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_publications',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_citations',
            metricType: 'perCapita',
          },
        ],
        weaknesses: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_citations',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_patent_grants',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_notable_ml_models',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_citations',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_patent_grants',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_notable_ml_models',
            metricType: 'perCapita',
          },
        ],
      },
      {
        publishYear: 2018,
        strengths: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_publications',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_publications',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_citations',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_publications',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_publications',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_citations',
            metricType: 'perCapita',
          },
        ],
        weaknesses: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_citations',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_patent_grants',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_notable_ml_models',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_citations',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_patent_grants',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_notable_ml_models',
            metricType: 'perCapita',
          },
        ],
      },
      {
        publishYear: 2019,
        strengths: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_publications',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_publications',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_citations',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_publications',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_publications',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_citations',
            metricType: 'perCapita',
          },
        ],
        weaknesses: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_citations',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_patent_grants',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_notable_ml_models',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_citations',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_patent_grants',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_notable_ml_models',
            metricType: 'perCapita',
          },
        ],
      },
      {
        publishYear: 2020,
        strengths: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_publications',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_publications',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_citations',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_publications',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_publications',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_citations',
            metricType: 'perCapita',
          },
        ],
        weaknesses: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_citations',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_patent_grants',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_notable_ml_models',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_citations',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_patent_grants',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_notable_ml_models',
            metricType: 'perCapita',
          },
        ],
      },
      {
        publishYear: 2021,
        strengths: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_publications',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_publications',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_citations',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_publications',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_publications',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_citations',
            metricType: 'perCapita',
          },
        ],
        weaknesses: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_citations',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_patent_grants',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_notable_ml_models',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_citations',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_patent_grants',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_notable_ml_models',
            metricType: 'perCapita',
          },
        ],
      },
      {
        publishYear: 2022,
        strengths: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_publications',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_publications',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_citations',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_publications',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_publications',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_citations',
            metricType: 'perCapita',
          },
        ],
        weaknesses: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_citations',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_patent_grants',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_notable_ml_models',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_citations',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_patent_grants',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_notable_ml_models',
            metricType: 'perCapita',
          },
        ],
      },
      {
        publishYear: 2023,
        strengths: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_publications',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_publications',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_conference_citations',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_publications',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_publications',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_citations',
            metricType: 'perCapita',
          },
          {
            index: 4,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_conference_citations',
            metricType: 'perCapita',
          },
        ],
        weaknesses: [
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_journal_citations',
            metricType: 'absolute',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_total_patent_grants',
            metricType: 'absolute',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_number_of_notable_ml_models',
            metricType: 'absolute',
          },
          {
            index: 1,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_journal_citations',
            metricType: 'perCapita',
          },
          {
            index: 2,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_total_patent_grants',
            metricType: 'perCapita',
          },
          {
            index: 3,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            metricSmallName: 'norm_pc_number_of_notable_ml_models',
            metricType: 'perCapita',
          },
        ],
      },
    ],
  },
]
